import { atom } from 'jotai'
import type { createStore } from 'jotai'
import { atomWithQuery } from 'jotai-tanstack-query'
import { hc, type InferResponseType } from 'hono/client'
import type { ComponentNewApi } from '@backend/api/stores/ComponentNewStore'
import { apiFetch, FormError } from '@paraflow-ai/frontend-libs'

type Store = ReturnType<typeof createStore>
const api = hc<ComponentNewApi>('/api/stores/componentNew', { fetch: apiFetch })

type FormState = {
  name: string
  description: string
  categoryId: string
  codeSnippet: string
  propsDoc: string
  guidelines: string
  tags: string
  isSubmitting: boolean
}

const defaultFormState: FormState = {
  name: '',
  description: '',
  categoryId: '',
  codeSnippet: '',
  propsDoc: '',
  guidelines: '',
  tags: '',
  isSubmitting: false,
}

export const formStateAtom = atom<FormState>(defaultFormState)

export const refreshAtom = atomWithQuery(() => ({
  queryKey: ['ComponentNewStore'],
  queryFn: async () => {
    const res = await api.refresh.$get()
    return await res.json()
  },
}))

export const updateFormAtom = atom(null, (get, set, updates: Partial<FormState>) => {
  set(formStateAtom, { ...get(formStateAtom), ...updates })
})

export const submitAtom = atom(null, async (get, set) => {
  const state = get(formStateAtom)
  if (!state.name.trim()) throw new FormError('请输入组件名称')

  set(formStateAtom, { ...state, isSubmitting: true })
  try {
    const res = await api.submit.$post({
      json: {
        name: state.name.trim(),
        description: state.description.trim() || undefined,
        categoryId: state.categoryId || undefined,
        codeSnippet: state.codeSnippet || undefined,
        propsDoc: state.propsDoc || undefined,
        guidelines: state.guidelines || undefined,
        tags: state.tags || undefined,
      },
    })
    const created = await res.json()
    return created
  } finally {
    set(formStateAtom, { ...get(formStateAtom), isSubmitting: false })
  }
})

export function loader(store: Store) {
  store.set(formStateAtom, { ...defaultFormState })
  store.get(refreshAtom)
  return null
}
